import {Button} from "antd";
import styled from "styled-components";

export const CustomButton = styled(Button)`
    width: auto;

    & > #status-label {
        display: block;
    }

    & > #action-label {
        display: none;
    }

    &:hover > #status-label {
        display: none;
    }

    &:hover > #action-label {
        display: block;
    }

    @media (max-width: 768px) {
        width: 100%;
        height: auto;
        min-height: 44px;
        padding: 8px 12px;
        font-size: 13px;
        line-height: 1.4;
        white-space: normal;
        text-align: center;

        & > #status-label,
        & > #action-label {
            white-space: normal;
            word-break: break-word;
            text-align: center;
        }
    }
`;
